/**
 * Overridden: (original file : themes/answers-hitchhiker-theme/static/js/hours/open-status/constants.js)
 * line 20 add NEXT_OPENS_AT in OpenStatusStrings for community Bankers location type 
 */
export const OpenStatusTypes = {
  OPEN_24_HOURS: 'OPEN24',
  OPENS_TODAY: 'OPENSTODAY',
  OPENS_NEXT: 'OPENSNEXT',
  CLOSES_TODAY: 'CLOSESTODAY',
  CLOSES_NEXT: 'CLOSESNEXT',
  CLOSED: 'CLOSED'
};

export const OpenStatusStrings = {
  OPEN_24_HOURS: 'Open 24 Hours',
  CLOSED: 'Closed',
  OPENS_AT: 'Opens at',
  OPEN_NOW: 'Open Now',
  CLOSES_AT: 'Closes at',
  NEXT_OPENS_AT: 'Next Open at'
};